'use client';

import { useEffect, useRef } from 'react';

/** Only render from a verified authenticated shell; does not grant access to other apps. */
export function CynchAppLauncher({ authenticated, currentApp }: { authenticated: boolean; currentApp: string }) {
  const mount = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (!authenticated || !mount.current) return;
    let cancelled = false;
    let launcher: HTMLElement | undefined;
    if (!customElements.get('cynch-app-launcher') && !document.getElementById('cynch-launcher-script')) {
      const script = document.createElement('script');
      script.id = 'cynch-launcher-script'; script.src = '/cynch-app-launcher.js';
      document.head.appendChild(script);
    }
    void customElements.whenDefined('cynch-app-launcher').then(() => {
      if (cancelled || !mount.current) return;
      launcher = document.createElement('cynch-app-launcher');
      launcher.setAttribute('authenticated', ''); launcher.setAttribute('current-app', currentApp);
      mount.current.appendChild(launcher);
    });
    return () => { cancelled = true; launcher?.remove(); };
  }, [authenticated, currentApp]);
  return authenticated ? <span ref={mount} style={{ display: 'inline-flex', flexShrink: 0 }} /> : null;
}
